import getIsInCheckedMode from 'mini-mail-list-view/lib/utils/getIsInCheckedMode';
import { getSelectedMailListItemsCount } from 'mini-mail-list-store';

/**
 * Returns the selected items count if in multi select mode
 * otherwise -1.
 */
export default function getSelectedItemsCount(): number {
    return getIsInCheckedMode() ? getSelectedMailListItemsCount() : -1;
}
